// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// export default function ScrollToTop() {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);

//   return null;
// }

 
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.history.scrollRestoration = "manual";

        const scrollToTop = () => {
            window.scrollTo(0, 0);
        };

        // Wait until the new page is rendered
        requestAnimationFrame(() => {
            requestAnimationFrame(scrollToTop);
        });

        // iOS Safari fallback
        const timer = setTimeout(scrollToTop, 100);

        return () => clearTimeout(timer);
    }, [pathname]);

    return null;
} 
